/**
 * sl-arc-heading.js — scroll morph: arc → straight line
 * Engine is DOM-driven (data-* on .sl-arc-heading). No GSAP.
 */
(function () {
  'use strict';

  var ROOT = '.sl-arc-heading';
  var instances = [];
  var ticking = false;
  var listening = false;

  function num(v, fallback) {
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  function clamp(v, a, b) {
    return Math.max(a, Math.min(b, v));
  }

  function ArcHeading(el) {
    this.el = el;
    this.textEl = el.querySelector('[data-sl-arc-text]');
    this.letters = [];
    this.progress = 0;
    this.readSettings();
    this.buildLetters();
    this.update(true);
  }

  ArcHeading.prototype.readSettings = function () {
    var d = this.el.dataset;
    this.intensity = num(d.arcIntensity, 50) / 100;
    this.stickerAt = num(d.stickerAt, 75) / 100;
    this.morphStart = num(d.morphStart, 80) / 100;
    this.morphEnd = num(d.morphEnd, 45) / 100;
  };

  ArcHeading.prototype.buildLetters = function () {
    if (!this.textEl) return;
    var raw = this.textEl.getAttribute('data-label') || this.textEl.textContent || '';
    raw = raw.replace(/\s+/g, ' ').trim();
    if (!raw) return;

    this.textEl.textContent = '';
    this.letters = [];

    for (var i = 0; i < raw.length; i++) {
      var ch = raw.charAt(i);
      var span = document.createElement('span');
      span.className = 'sl-arc-heading__letter';
      span.setAttribute('aria-hidden', 'true');
      if (ch === ' ') {
        span.className += ' sl-arc-heading__letter--space';
        span.innerHTML = '&nbsp;';
      } else {
        span.textContent = ch;
      }
      this.textEl.appendChild(span);
      this.letters.push(span);
    }

    /* Accessible name stays on the link/heading via aria-label / visible text rebuilt */
    this.textEl.setAttribute('aria-label', raw);
  };

  ArcHeading.prototype.computeProgress = function () {
    var rect = this.el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    /* morphStart/End are % of viewport from the top.
       Start is LOWER on screen (larger %) = section arriving → arc (0).
       End is HIGHER (smaller %) = section centered → straight (1). */
    var startTop = this.morphStart * vh;
    var endTop = this.morphEnd * vh - rect.height / 2;
    if (endTop >= startTop) endTop = startTop - 1;
    if (rect.top >= startTop) return 0;
    if (rect.top <= endTop) return 1;
    return clamp((startTop - rect.top) / (startTop - endTop), 0, 1);
  };

  ArcHeading.prototype.applyTransforms = function (progress) {
    var n = this.letters.length;
    if (!n) return;

    var curve = this.intensity * (1 - progress);
    var width = this.textEl ? this.textEl.offsetWidth : 0;
    var fontSize = parseFloat(window.getComputedStyle(this.textEl).fontSize) || 48;
    /* Medium intensity (0.5) ≈ 14% of text width as center sag */
    var arcLift = (width || fontSize * Math.max(n, 1) * 0.5) * 0.28 * curve;
    var maxRotate = 36 * curve;

    for (var i = 0; i < n; i++) {
      var t = n === 1 ? 0 : (i / (n - 1)) * 2 - 1;
      var y = -arcLift * (1 - t * t);
      var rot = t * maxRotate;
      this.letters[i].style.transform =
        'translate3d(0,' + y.toFixed(2) + 'px,0) rotate(' + rot.toFixed(3) + 'deg)';
    }

    var stickerOn = progress >= this.stickerAt;
    this.el.classList.toggle('is-sticker', stickerOn);
    this.el.classList.toggle('is-straight', progress >= 0.98);
    this.el.style.setProperty('--sl-arc-progress', String(progress));
  };

  ArcHeading.prototype.update = function () {
    this.readSettings();
    this.progress = this.computeProgress();
    this.applyTransforms(this.progress);
  };

  function scan(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll(ROOT);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.__slArcHeading) {
        el.__slArcHeading.readSettings();
        el.__slArcHeading.update();
        continue;
      }
      var inst = new ArcHeading(el);
      el.__slArcHeading = inst;
      instances.push(inst);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      for (var i = 0; i < instances.length; i++) instances[i].update();
    });
  }

  function ensureListeners() {
    if (listening) return;
    listening = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function boot(root) {
    scan(root);
    if (instances.length) ensureListeners();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector(ROOT);
    if (!el || !el.__slArcHeading) return;
    instances = instances.filter(function (inst) {
      return inst.el !== el;
    });
    el.__slArcHeading = null;
  });
})();
